module.exports = __webpack_public_path__ + "static/img/Exercise_Plan.4d45569.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/doctors/Exercise_Plan.jpg
// module id = REBU
// module chunks = 7